// extracted by mini-css-extract-plugin
export default {"sortable":"_2MvBtZUH","fetching":"_3S3HN3hi"};